import React from 'react'
import style from '../auth.module.scss'

function AuthCard({ children, title, desc }) {
  return (
    <div className={style["auth-card"]}>
      <div className="flex flex-column gap-3 align-center">
        <h5 className={style["card-title"]}>{title}</h5>
        <p className={style["card-desc"]}>{desc}</p>
      </div>
      {children}
    </div>
  )
}

export default AuthCard